module.exports = __webpack_public_path__ + "img/tutorial_two_fr.17a7d126.png";